<app-page-loader *ngIf="loading"></app-page-loader>
<!-- Deleting the organisation: loader with a label instead of the page
     (CLAUDE.md Regel 19, Stufe C) - nothing can be started a second time. -->
<app-page-loader
  *ngIf="deletingOrganisation"
  [label]="'pages.organisation.deletingOrganisation' | translate"
></app-page-loader>

<div *ngIf="!loading && !deletingOrganisation">
  <div class="header">
    <h2>{{ organisation?.company_name || "Organisation" }}</h2>
  </div>

  <!-- Die Seite ist ueber die Jahre gewachsen; ohne Gliederung stand alles
       untereinander. Vier Bereiche mit Platz nach oben statt einer Liste.
       nb-tabset ist hier das Hausmuster (Moodle-Dashboard, ILIAS-Dashboard,
       Wissensbasis nutzen es ebenso) und laesst die zweispaltige Kachel-
       Anordnung in voller Breite -- eine linke Navigation wie beim Agenten
       wuerde sie schmaler machen, ohne hier etwas zu gewinnen. -->
  <nb-tabset (changeTab)="onTabChange($event.tabId)">
    <nb-tab
      tabId="general"
      [active]="activeTab === 'general'"
      [tabTitle]="'pages.organisation.tabs.general' | translate"
      tabIcon="briefcase-outline"
    >
      <div class="container">
        <nb-card>
          <nb-card-header>
            <h6><nb-icon icon="briefcase-outline"></nb-icon>{{ "pages.organisation.titleGeneral" | translate }}</h6>
          </nb-card-header>
          <nb-card-body>
            <app-organisation-general-form></app-organisation-general-form>
          </nb-card-body>
        </nb-card>

        <nb-card>
          <nb-card-header>
            <h6><nb-icon icon="pin-outline"></nb-icon>{{ "pages.organisation.titleAddress" | translate }}</h6>
          </nb-card-header>
          <nb-card-body>
            <app-organisation-address-form></app-organisation-address-form>
          </nb-card-body>
        </nb-card>
      </div>
    </nb-tab>

    <nb-tab
      tabId="billing"
      [active]="activeTab === 'billing'"
      [tabTitle]="'pages.organisation.tabs.billing' | translate"
      tabIcon="credit-card-outline"
    >
      <div class="container container--billing">
        <!-- Individueller Vertrag (Migration 081): Abrechnung per Rechnung,
             daher statt der Stripe-Zahlungskarte die Vertragskonditionen. -->
        <nb-card *ngIf="isContract" class="contract-card" [nbSpinner]="contractLoading" nbSpinnerStatus="primary">
          <nb-card-header>
            <h6><nb-icon icon="credit-card-outline"></nb-icon>{{ "pages.organisation.contract.title" | translate }}</h6>
          </nb-card-header>
          <nb-card-body>
            <div class="payment">
              <div class="item">
                <span>{{ "pages.organisation.aboPlanLabel" | translate }}:</span>
                {{ activeProdcutName }}
              </div>
              @if (contract; as c) {
              <div class="item">
                <span>{{ "pages.organisation.contract.term" | translate }}:</span>
                {{ c.starts_on | date : "dd.MM.yyyy" }}
                @if (c.ends_on) {
                  {{ "words.to" | translate }} {{ c.ends_on | date : "dd.MM.yyyy" }}
                } @else {
                  {{ "pages.organisation.contract.openEnded" | translate }}
                }
              </div>
              @if (c.renewal === "auto" && c.ends_on) {
              <div class="item">
                <span>{{ "pages.organisation.contract.renewal" | translate }}:</span>
                {{ "pages.organisation.contract.renewalAuto" | translate }}
              </div>
              }
              @if (c.notice_days) {
              <div class="item">
                <span>{{ "pages.organisation.contract.notice" | translate }}:</span>
                {{ "pages.organisation.contract.days" | translate : { days: c.notice_days } }}
              </div>
              }
              <div class="item">
                <span>{{ "pages.organisation.contract.baseFee" | translate }}:</span>
                {{ c.base_fee_net_cents / 100 | currency : c.currency || "EUR" }}
                {{ "pages.organisation.contract.cyclePer." + c.billing_cycle | translate }}
              </div>
              <div class="item">
                <span>{{ "pages.organisation.contract.paymentTerms" | translate }}:</span>
                {{ "pages.organisation.contract.days" | translate : { days: c.payment_terms_days } }}
              </div>
              @if (contractLimitRows.length) {
              <div class="contract-limits">
                <span class="contract-limits__title">{{ "pages.organisation.contract.limits" | translate }}</span>
                @for (row of contractLimitRows; track row.key) {
                <div class="item">
                  <span>{{ "dialogs.contract.limits." + row.key | translate }}:</span>
                  {{ row.value }}
                </div>
                }
              </div>
              }
              } @else if (!authService.isAdmin()) {
              <p class="contract-hint">{{ "pages.organisation.contract.detailsAdminOnly" | translate }}</p>
              }
            </div>
          </nb-card-body>
        </nb-card>

        <nb-card *ngIf="!isContract">
          <nb-card-header>
            <h6><nb-icon icon="credit-card-outline"></nb-icon>{{ "pages.organisation.titlePayment" | translate }}</h6>
          </nb-card-header>
          <nb-card-body>
            <div class="payment">
              <div class="item">
                <span>{{ "pages.organisation.aboPlanLabel" | translate }}:</span>
                {{ activeProdcutName | translate }}
              </div>
              <div class="item">
                <span>{{ "pages.organisation.aboPriceLabel" | translate }}:</span>
                {{ productPrice | currency }}
              </div>
              <div class="item">
                <span>{{ "pages.organisation.periodLabel" | translate }}:</span>
                {{ organisation?.cycle_start_date | date : "shortDate" : "CET" }}
                {{ "words.to" | translate }}
                {{ organisation?.cycle_end_date | date : "shortDate" : "CET" }}
              </div>

              @if(productService.currentPlan$.value?.scheduled_downgrade_plan){
              <div class="item">
                <span>{{ "pages.organisation.downgradeLabel" | translate }}:</span>
                {{
                  productService.currentPlan$.value?.scheduled_downgrade_plan
                    | date : "shortDate" : "CET"
                }}
                {{ "words.after" | translate }}
                {{
                  productService.getPlanById(
                    productService.currentPlan$.value?.scheduled_downgrade_plan
                  )!.name | translate
                }}
              </div>
              }

              <!-- Payment method Stripe will actually charge (admins only) -->
              @if(paymentMethod?.has_customer){
              <div class="item">
                <span class="pm-label">{{ "pages.organisation.paymentMethod.label" | translate }}:</span>
                @if(paymentMethod?.payment_method; as pm){
                  @if(pm.type === 'card'){
                    <span class="pm-value">{{ (pm.brand || '') | titlecase }} •••• {{ pm.last4 }}</span>
                    @if(pm.exp_month && pm.exp_year){
                    <span class="pm-meta" [class.pm-danger]="pm.expired" [class.pm-caution]="pm.expiring_soon">
                      {{ "pages.organisation.paymentMethod.validUntil" | translate }}
                      {{ pm.exp_month | number : "2.0" }}/{{ pm.exp_year % 100 | number : "2.0" }}
                    </span>
                    }
                  } @else if(pm.type === 'sepa_debit'){
                    <span class="pm-value">{{ "pages.organisation.paymentMethod.sepa" | translate }} •••• {{ pm.last4 }}</span>
                  } @else {
                    <span class="pm-value">{{ pm.type }} {{ pm.last4 ? "•••• " + pm.last4 : "" }}</span>
                  }
                } @else if(paymentMethod?.collection_method === 'send_invoice'){
                  <span class="pm-value">{{ "pages.organisation.paymentMethod.byInvoice" | translate }}</span>
                } @else if(paymentMethod?.source === 'legacy_source'){
                  <span class="pm-value">{{ "pages.organisation.paymentMethod.legacySource" | translate }}</span>
                } @else {
                  <span class="pm-value pm-danger">{{ "pages.organisation.paymentMethod.none" | translate }}</span>
                }
              </div>
              @if(paymentMethodMissing){
              <div class="pm-alert">
                {{
                  (paymentMethod?.attached_count
                    ? "pages.organisation.paymentMethod.noDefaultButAttached"
                    : "pages.organisation.paymentMethod.missingHint") | translate
                }}
              </div>
              } @else if(paymentMethod?.payment_method?.expired){
              <div class="pm-alert">{{ "pages.organisation.paymentMethod.expiredHint" | translate }}</div>
              } @else if(paymentMethod?.payment_method?.expiring_soon){
              <div class="pm-alert pm-alert--caution">{{ "pages.organisation.paymentMethod.expiringHint" | translate }}</div>
              }
              }
              @if(paymentMethod?.payment_grace_until){
              <div class="pm-alert">
                {{ "pages.organisation.paymentMethod.graceHint" | translate : { date: (paymentMethod!.payment_grace_until | date : "dd.MM.yyyy, HH:mm") } }}
              </div>
              } @else if(organisation?.subscription_status === 'past_due'){
              <div class="pm-alert">{{ "pages.organisation.paymentMethod.pastDueHint" | translate }}</div>
              }

              <!-- subscription_start_date -->
              <div class="item red" *ngIf="organisation?.subscription_end_date">
                <span>{{ "pages.organisation.cancelledLabel" | translate }}:</span>
                {{
                  organisation?.subscription_end_date | date : "shortDate" : "CET"
                }}
              </div>
            </div>
          </nb-card-body>
          @if(authService.hasAccess(authService.UserAccess.OrganisationManageSubscription)){
          <nb-card-footer>
            <!-- Internal: Stripe dashboard deep link, returned to super admins only -->
            @if(paymentMethod?.stripe_dashboard; as sd){
            <a
              nbButton
              status="basic"
              outline=""
              class="stripe-dashboard-btn"
              [href]="sd.customer_url"
              target="_blank"
              rel="noopener"
              [nbTooltip]="'pages.organisation.paymentMethod.stripeDashboardTip' | translate : { account: ((sd.live ? 'pages.organisation.paymentMethod.stripeAccountLive' : 'pages.organisation.paymentMethod.stripeAccountSandbox') | translate) }"
              nbTooltipPlacement="top"
            >
              <nb-icon icon="stripe" pack="al"></nb-icon>
              <span>{{ "pages.organisation.paymentMethod.stripeDashboard" | translate }}</span>
            </a>
            }
            @if(paymentMethod?.has_customer){
            <button nbButton status="basic" outline="" [disabled]="billingPortalOpening" (click)="onOpenBillingPortal()">
              <span>{{ "pages.organisation.paymentMethod.manage" | translate }}</span>
              <nb-icon icon="external-link-outline"></nb-icon>
            </button>
            }
            <button nbButton status="primary" outline="" [routerLink]="'/products'">
              <span>{{ "words.subscription" | translate }}</span>
              <nb-icon icon="edit"></nb-icon>
            </button>
          </nb-card-footer>
          }
        </nb-card>

        <!-- Row 1: payment and invoices side by side. -->
        <nb-card>
          <nb-card-header>
            <h6><nb-icon icon="file-text-outline"></nb-icon>{{ "pages.organisation.titleInvoices" | translate }}</h6>
          </nb-card-header>
          <nb-card-body>
            <!-- Vertragskunden: Rechnungen aus alphacount statt Stripe
                 (nur admin/super_admin, wie die Vertragskarte). -->
            @if (isContract) {
            @if (contractInvoicesLoading && !contractInvoices.length) {
            <app-orbi-loader [size]="72"></app-orbi-loader>
            } @else {
            <div class="invoices">
              @for (i of contractInvoices; track i.id) {
              <div class="invoice invoice--contract">
                <div class="icon">
                  <nb-icon icon="file-text-outline" status="primary"></nb-icon>
                </div>
                <div class="title">{{ i.number }}</div>
                <div class="info info--stack">
                  @if (i.service_start || i.usage_start) {
                  <span>{{ (i.service_start || i.usage_start) | date : "dd.MM.yyyy" }} – {{ i.periodTo | date : "dd.MM.yyyy" }}</span>
                  }
                  @if (i.due_date && i.status !== "paid" && i.status !== "cancelled") {
                  <span>{{ "pages.organisation.contract.invoiceDue" | translate : { date: (i.due_date | date : "dd.MM.yyyy") } }}</span>
                  }
                </div>
                <div class="info info--stack {{ i.status === 'paid' ? 'paid' : '' }}">
                  <span>{{ (i.total_gross_cents ?? i.net_cents) / 100 | currency }}</span>
                  <span>{{ "enums.contractInvoiceStatus." + i.status | translate }}</span>
                </div>
                <div class="actions">
                  @if (i.has_pdf) {
                  <button
                    nbButton
                    status="primary"
                    [disabled]="!!downloadingInvoiceId"
                    [nbSpinner]="downloadingInvoiceId === i.id"
                    [attr.aria-label]="'pages.organisation.contract.downloadInvoice' | translate"
                    (click)="onDownloadContractInvoice(i)"
                  >
                    <nb-icon icon="download"></nb-icon>
                  </button>
                  }
                </div>
              </div>
              } @empty {
              <p class="contract-hint">{{ "pages.organisation.contract.invoicesNote" | translate }}</p>
              }
            </div>
            }
            }
            <div class="invoices" *ngIf="!isContract">
              @for (i of invoices; track i.number) {
              <div class="invoice" (click)="openStripe(i)">
                <div class="icon">
                  <nb-icon icon="file-text-outline" status="primary"></nb-icon>
                </div>
                <div class="title">{{ i.number }}</div>
                <div class="info">
                  {{ i.created * 1000 | date : "shortDate" : "CET" }}
                </div>
                <div class="info {{ i.paid ? 'paid' : '' }}">
                  {{ i.total / 100 | currency }}
                </div>
                <div class="actions">
                  <button
                    nbButton
                    status="primary"
                    *ngIf="i.paid"
                    (click)="onDownloadInvoice($event, i)"
                  >
                    <nb-icon icon="download"></nb-icon>
                  </button>
                </div>
              </div>
              } @empty {
              <p>{{ "pages.organisation.noInvoices" | translate }}.</p>
              }
            </div>
          </nb-card-body>
        </nb-card>

        <!-- Row 2, full width. -->
        <!-- KI-Kontingent (credits). Billing: admin and super_admin, never
             manager. The backend enforces the same roles on every mutation
             (credits_endpoints._BILLING_ROLES). -->
        @if(authService.isAdmin()){
        <nb-card class="credits-card" [nbSpinner]="creditsLoading" nbSpinnerStatus="primary">
          <nb-card-header>
            <h6><nb-icon icon="flash-outline"></nb-icon>{{ "pages.organisation.credits.title" | translate }}</h6>
          </nb-card-header>
          <nb-card-body>
            <ng-container *ngIf="creditService.balance$ | async as balance">
              <!-- Full-width card: balance across the top, top-up and
                   spending limit side by side, notifications below. -->
              <div class="credits-layout">
              <!-- 1. Guthaben — Stat-Kacheln -->
              <section class="tile-flat">
                <header class="tile-flat__header">
                  <h5 class="section-title">
                    {{ "pages.organisation.credits.balance.title" | translate }}
                    <nb-icon
                      class="info-icon"
                      icon="question-mark-circle-outline"
                      [nbTooltip]="'pages.organisation.credits.balance.hint' | translate"
                      nbTooltipPlacement="top"
                    ></nb-icon>
                  </h5>
                  <button
                    nbButton
                    ghost
                    size="small"
                    status="primary"
                    type="button"
                    class="credits-explain-btn"
                    (click)="openCreditsInfo()"
                  >
                    <nb-icon icon="info-outline"></nb-icon>
                    {{ "pages.organisation.credits.info.open" | translate }}
                  </button>
                </header>
                <div class="stat-grid">
                  <div class="stat-tile">
                    <nb-icon class="stat-icon" icon="award-outline"></nb-icon>
                    <span
                      class="stat-label"
                      [nbTooltip]="'pages.organisation.credits.balance.planTip' | translate"
                      nbTooltipPlacement="top"
                    >{{ "pages.organisation.credits.balance.plan" | translate }}</span>
                    <strong class="stat-value" *ngIf="planCreditsRemaining !== null">
                      {{ planCreditsRemaining | number }}
                    </strong>
                    <strong class="stat-value" *ngIf="planCreditsRemaining === null">
                      {{ "pages.organisation.credits.unlimited" | translate }}
                    </strong>
                  </div>
                  <div class="stat-tile stat-tile--accent">
                    <nb-icon class="stat-icon" icon="flash-outline"></nb-icon>
                    <span
                      class="stat-label"
                      [nbTooltip]="'pages.organisation.credits.balance.creditsTip' | translate"
                      nbTooltipPlacement="top"
                    >{{ "pages.organisation.credits.balance.credits" | translate }}</span>
                    <strong class="stat-value">{{ balance.credits_remaining | number }}</strong>
                  </div>
                  <div class="stat-tile">
                    <nb-icon class="stat-icon" icon="pie-chart-outline"></nb-icon>
                    <span
                      class="stat-label"
                      [nbTooltip]="'pages.organisation.credits.balance.combinedTip' | translate"
                      nbTooltipPlacement="top"
                    >{{ "pages.organisation.credits.balance.combined" | translate }}</span>
                    <strong class="stat-value" *ngIf="totalCreditsAvailable !== null">
                      {{ totalCreditsAvailable | number }}
                    </strong>
                    <strong class="stat-value" *ngIf="totalCreditsAvailable === null">
                      {{ "pages.organisation.credits.unlimited" | translate }}
                    </strong>
                    <span class="stat-sub" *ngIf="balance.credits_oldest_expires_at">
                      {{ "pages.organisation.credits.balance.expires" | translate }}
                      {{ balance.credits_oldest_expires_at | date : "shortDate" : "CET" }}
                    </span>
                  </div>
                </div>
                <nb-progress-bar
                  *ngIf="creditsUsedPercent !== null"
                  [value]="creditsUsedPercent"
                  [status]="creditsUsedPercent >= 90 ? 'danger' : creditsUsedPercent >= 70 ? 'warning' : 'primary'"
                  size="tiny"
                ></nb-progress-bar>

                <p class="cannot-buy" *ngIf="!balance.can_buy">
                  <nb-icon icon="alert-circle-outline"></nb-icon>
                  {{ "pages.organisation.credits.cannotBuy." + balance.cannot_buy_reason | translate }}
                </p>
              </section>

              <!-- 2. Aufladen: Credits kaufen + Auto-Aufladung -->
              <section class="tile-flat" *ngIf="creditService.settings$ | async as settings">
                <header class="tile-flat__header">
                  <h5 class="section-title">
                    {{ "pages.organisation.credits.actions.title" | translate }}
                  </h5>
                </header>

                <div class="paused" *ngIf="settings.auto_recharge_paused_reason">
                  <nb-icon icon="alert-triangle-outline" status="warning"></nb-icon>
                  <span>
                    {{ "pages.organisation.credits.autoRecharge.paused." + settings.auto_recharge_paused_reason | translate }}
                  </span>
                  <button nbButton size="small" status="warning" (click)="acknowledgeAutoRecharge()">
                    {{ "pages.organisation.credits.autoRecharge.reactivate" | translate }}
                  </button>
                </div>

                <div class="action-buttons">
                  <span
                    [nbTooltip]="'pages.organisation.credits.cannotBuy.' + balance.cannot_buy_reason | translate"
                    [nbTooltipDisabled]="balance.can_buy"
                    nbTooltipPlacement="top"
                  >
                    <button nbButton status="primary" [disabled]="!balance.can_buy" (click)="openBuyCredits()">
                      <nb-icon icon="plus-circle-outline"></nb-icon>
                      <span>{{ "pages.organisation.credits.buy" | translate }}</span>
                    </button>
                  </span>
                  <button nbButton outline status="primary" type="button" (click)="openCreditsInfo()">
                    <nb-icon icon="pie-chart-outline"></nb-icon>
                    <span>{{ "pages.organisation.credits.info.calcButton" | translate }}</span>
                  </button>
                  <button
                    nbButton
                    status="basic"
                    [nbTooltip]="'pages.organisation.credits.autoRecharge.hint' | translate"
                    nbTooltipPlacement="top"
                    (click)="onAutoRechargeToggle(!settings.auto_recharge_enabled, settings)"
                  >
                    <nb-icon icon="flip-2-outline"></nb-icon>
                    <span>{{
                      (settings.auto_recharge_enabled
                        ? "pages.organisation.credits.autoRecharge.manage"
                        : "pages.organisation.credits.autoRecharge.setup"
                      ) | translate
                    }}</span>
                  </button>
                </div>

                <!-- Auto-recharge active status + summary -->
                <div class="ar-summary" *ngIf="settings.auto_recharge_enabled">
                  <div class="ar-status">
                    <nb-icon icon="checkmark-circle-2-outline" status="success"></nb-icon>
                    {{ "pages.organisation.credits.autoRecharge.activeSummary" | translate:
                        { threshold: settings.auto_recharge_threshold_eur, amount: settings.auto_recharge_amount_eur } }}
                  </div>
                  <p class="tile__hint" *ngIf="settings.last_auto_recharge_at">
                    {{ "pages.organisation.credits.autoRecharge.last" | translate }}:
                    {{ settings.last_auto_recharge_at | date : "short" : "CET" }}
                  </p>
                  <div class="ar-summary__actions">
                    <button nbButton size="small" status="basic" (click)="editAutoRecharge(settings)">
                      <nb-icon icon="edit-outline"></nb-icon>
                      {{ "pages.organisation.credits.autoRecharge.edit" | translate }}
                    </button>
                    <button nbButton size="small" ghost status="danger" (click)="onAutoRechargeToggle(false, settings)">
                      {{ "pages.organisation.credits.autoRecharge.dialog.disable" | translate }}
                    </button>
                  </div>
                </div>
              </section>

              <!-- 3. Ausgabenlimit (optional) -->
              <section class="tile-flat" *ngIf="creditService.settings$ | async as settings">
                <header class="tile-flat__header">
                  <h5 class="section-title">
                    {{ "pages.organisation.credits.limit.title" | translate }}
                    <nb-icon
                      class="info-icon"
                      icon="question-mark-circle-outline"
                      [nbTooltip]="'pages.organisation.credits.limit.hint' | translate"
                      nbTooltipPlacement="top"
                    ></nb-icon>
                  </h5>
                </header>
                <div class="setting-row">
                  <label>{{ "pages.organisation.credits.limit.enabled" | translate }}</label>
                  <nb-toggle
                    [checked]="settings.auto_recharge_monthly_cap_enabled"
                    (checkedChange)="onLimitToggle($event, settings)"
                  ></nb-toggle>
                </div>
                <!-- Value is always enterable; Enter/blur commits it and switches the
                     limit on. The toggle above just turns it off again. -->
                <div class="setting-row">
                  <label>{{ "pages.organisation.credits.limit.amount" | translate }}</label>
                  <nb-form-field>
                    <span nbPrefix>€</span>
                    <input
                      #limitInput
                      nbInput
                      fullWidth
                      type="number"
                      min="10"
                      step="1"
                      [ngModel]="settings.auto_recharge_monthly_cap_eur ?? 100"
                      (blur)="onLimitAmountChange(limitInput.value)"
                      (keyup.enter)="onLimitAmountChange(limitInput.value)"
                    />
                  </nb-form-field>
                </div>
                <p class="tile__hint" *ngIf="!settings.auto_recharge_monthly_cap_enabled">
                  {{ "pages.organisation.credits.limit.offHint" | translate }}
                </p>
              </section>

              <!-- 4. E-Mail-Benachrichtigung -->
              <section class="tile-flat" *ngIf="creditService.settings$ | async as settings">
                <header class="tile-flat__header">
                  <h5 class="section-title">
                    {{ "pages.organisation.credits.alerts.title" | translate }}
                    <nb-icon
                      class="info-icon"
                      icon="question-mark-circle-outline"
                      [nbTooltip]="'pages.organisation.credits.alerts.hint' | translate"
                      nbTooltipPlacement="top"
                    ></nb-icon>
                  </h5>
                </header>
                <div class="threshold-chips">
                  <button
                    *ngFor="let t of alertChoices"
                    type="button"
                    nbButton
                    size="tiny"
                    [status]="settings.alert_thresholds.includes(t) ? 'primary' : 'basic'"
                    (click)="toggleAlertThreshold(settings, t)"
                  >
                    {{ t }}%
                  </button>
                </div>
                <div class="setting-row">
                  <label
                    [nbTooltip]="'pages.organisation.credits.alerts.useDefaultTip' | translate"
                    nbTooltipPlacement="top"
                  >{{ "pages.organisation.credits.alerts.useDefault" | translate }}</label>
                  <nb-toggle
                    [checked]="settings.alert_thresholds_is_default"
                    (checkedChange)="setAlertsDefault($event)"
                  ></nb-toggle>
                </div>
              </section>
              </div>
            </ng-container>
          </nb-card-body>
        </nb-card>
        }

      </div>
    </nb-tab>

    <nb-tab
      tabId="users"
      [active]="activeTab === 'users'"
      [tabTitle]="'pages.organisation.tabs.users' | translate"
      tabIcon="people-outline"
    >
      <!-- Feature Sets Section -->
      <div *ngIf="showFeatureSets">
        <nb-card>
          <nb-card-header>
            <div class="header-row">
              <h6><nb-icon icon="options-2-outline"></nb-icon>{{ "pages.organisation.featureSets.title" | translate }}</h6>
              <button
                nbButton
                size="small"
                status="primary"
                outline
                (click)="openFeatureSetDialog()"
              >
                <nb-icon icon="plus"></nb-icon>
                {{ "pages.organisation.featureSets.create" | translate }}
              </button>
            </div>
            <p class="card-description">
              {{ "pages.organisation.featureSets.description" | translate }}
            </p>
          </nb-card-header>
          <nb-card-body>
            <table class="feature-sets-table" *ngIf="featureSets.length > 0">
              <thead>
                <tr>
                  <th>{{ "pages.organisation.featureSets.nameLabel" | translate }}</th>
                  <th>{{ "pages.organisation.featureSets.permissions" | translate }}</th>
                  <th class="actions-col"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let fs of featureSets">
                  <td>
                    <div class="name-cell">
                      <strong>{{ getFeatureSetDisplayName(fs) }}</strong>
                      <span class="badge default" *ngIf="fs.is_default">Default</span>
                    </div>
                  </td>
                  <td>
                    <div class="perm-chips">
                      <span
                        class="chip"
                        *ngFor="let perm of displayPermissions(fs.permissions)"
                      >
                        {{ "enums.featureSetPermissions." + perm + ".label" | translate }}
                      </span>
                      <span
                        class="chip empty"
                        *ngIf="displayPermissions(fs.permissions).length === 0"
                      >
                        {{ "pages.organisation.featureSets.empty" | translate }}
                      </span>
                    </div>
                  </td>
                  <td class="actions-col">
                    <button
                      nbButton
                      ghost
                      size="small"
                      status="primary"
                      (click)="openFeatureSetDialog(fs)"
                    >
                      <nb-icon icon="edit"></nb-icon>
                    </button>
                    <button
                      nbButton
                      ghost
                      size="small"
                      status="danger"
                      (click)="deleteFeatureSet(fs)"
                      [disabled]="fs.is_default"
                    >
                      <nb-icon icon="trash-2"></nb-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <p class="empty-state" *ngIf="featureSets.length === 0">
              {{ "pages.organisation.featureSets.empty" | translate }}
            </p>
          </nb-card-body>
        </nb-card>
      </div>

      <div class="header">
        <h6><nb-icon icon="people-outline"></nb-icon>{{ "pages.organisation.titleUsers" | translate }}</h6>

        <button nbButton status="primary" outline="" alAnchor="org.add-user" (click)="onAddUser()">
          <span>{{ "buttons.add" | translate }}</span>
          <nb-icon icon="plus"></nb-icon>
        </button>
      </div>

      <div class="grid">
        <div class="card" *ngFor="let u of userService.users$ | async">
          <div
            class="img"
            [ngStyle]="{
              'background-image': 'url(' + userService.getAvatar(u.email) + ')'
            }"
          ></div>
          <div class="title">{{ u.name }}</div>
          <div class="info">
            <span>
              {{ u.email }}
            </span>
          </div>
          <div class="info">
            @if(u.must_change_password && !u.last_login){
            {{ "words.invited" | translate }}
            } @else if(u.must_change_password && u.last_login){
            <span class="status-onboarding">{{ "words.onboarding" | translate }}</span>
            } @else {

            <span class="role">{{ u.role }}</span>
            }
          </div>
          <div class="info">
            @if(u.last_login){
            <span>
              {{ "pages.organisation.lastLogin" | translate }}:
              {{ u.last_login | dateAgo }}
            </span>
            } @else {
            <span>{{ "pages.organisation.neverLoggedIn" | translate }}</span>
            }
          </div>
          <div class="info">
            <span> {{ u.created_at | dateAgo }}</span>
          </div>
          <div class="actions">
            @if(authService.hasAccess(authService.UserAccess.OrganisationEditUser)){
            <button nbButton ghost status="primary" (click)="onEditUser(u)">
              <nb-icon icon="edit"></nb-icon>
            </button>
            <!-- Only while the temporary password is still in place. Once the
                 invitee picked their own, the backend refuses (409) and the
                 way in is the password reset, not a new invitation. -->
            <button
              nbButton
              ghost
              status="basic"
              *ngIf="u.must_change_password"
              [disabled]="resendingInvitationFor === u.id"
              [nbTooltip]="'pages.organisation.invitations.resendTooltip' | translate"
              (click)="onResendInvitation(u)"
            >
              <nb-icon icon="email-outline"></nb-icon>
            </button>
            <!-- The way back in after a lost phone. Clears the factor; the
                 user enrols again at their next sign-in if the organisation
                 still requires one. -->
            <button
              nbButton
              ghost
              status="basic"
              *ngIf="authService.isAdmin()"
              [nbTooltip]="'pages.organisation.security.resetTooltip' | translate"
              (click)="onResetTwoFactor(u)"
            >
              <nb-icon icon="shield-off-outline"></nb-icon>
            </button>
            <button nbButton ghost status="danger" (click)="onDeleteUser(u)">
              <nb-icon icon="trash-2"></nb-icon>
            </button>
            }
          </div>
        </div>
      </div>
    </nb-tab>

    <nb-tab
      tabId="security"
      [active]="activeTab === 'security'"
      [tabTitle]="'pages.organisation.tabs.security' | translate"
      tabIcon="shield-outline"
    >
      <div class="container">
        <!-- Account security. Admin-only, because this switch decides how every
             member of the organisation signs in. -->
        <nb-card *ngIf="authService.isAdmin()">
          <nb-card-header>
            <h6><nb-icon icon="lock-outline"></nb-icon>{{ "pages.organisation.security.title" | translate }}</h6>
          </nb-card-header>
          <nb-card-body>
            <p class="page-hint">
              {{ "pages.organisation.security.hint" | translate }}
            </p>
            <nb-toggle
              [checked]="require2fa"
              [disabled]="require2faSaving"
              (checkedChange)="onRequire2faChange($event)"
            >
              {{ "pages.organisation.security.require2fa" | translate }}
            </nb-toggle>
            <p class="caption security-note">
              {{ "pages.organisation.security.learnersNote" | translate }}
            </p>
          </nb-card-body>
        </nb-card>

        <nb-card>
          <nb-card-header>
            <h6><nb-icon icon="shield-outline"></nb-icon>{{ "pages.organisation.avv.title" | translate }}</h6>
          </nb-card-header>
          <nb-card-body class="avv-card-body">
            <div class="avv-card">
              <div class="avv-status" [class.accepted]="organisation?.avv_accepted">
                <nb-icon
                  [icon]="organisation?.avv_accepted ? 'checkmark-circle-2-outline' : 'alert-circle-outline'"
                ></nb-icon>
                <div>
                  <strong>
                    {{
                      (organisation?.avv_accepted
                        ? "pages.organisation.avv.statusAccepted"
                        : "pages.organisation.avv.statusOpen") | translate
                    }}
                  </strong>
                  <p *ngIf="organisation?.avv_accepted_at">
                    {{ "pages.organisation.avv.acceptedAt" | translate }}
                    {{ organisation?.avv_accepted_at | date : "short" : "CET" }}
                  </p>
                  <p>
                    {{ "pages.organisation.avv.version" | translate }}
                    {{ organisation?.avv_version || "1.0" }}
                  </p>
                </div>
              </div>
            </div>
          </nb-card-body>
          <nb-card-footer>
            <button nbButton status="primary" outline (click)="openAvvDialog()">
              <nb-icon icon="file-text-outline"></nb-icon>
              {{ "pages.organisation.avv.open" | translate }}
            </button>
          </nb-card-footer>
        </nb-card>
      </div>
    </nb-tab>
  </nb-tabset>

  @if(authService.hasAccess(authService.UserAccess.OrganisationDelete)){
  <div class="footer">
    <button nbButton status="danger" outline="true" (click)="onDeleteClient()">
      <nb-icon icon="trash-2"></nb-icon>
      {{ "pages.organisation.deleteOrganisation" | translate }}
    </button>
  </div>
  }
</div>
